module.exports = "<div class=\"ui-g-12\">\n\t<div *ngIf=\"Loading\">\n\t\t<i class=\"fas fa-spinner fa-3x fa-spin\"></i><br /><br />\n\t\t<span style=\"font-weight: bold;\">Loading...</span>\n\t</div>\n\t<div *ngIf=\"!Loading\">\n\t\tTable Management Page\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-module/table-management/table-management.component.html
// module id = ./src/app/admin-module/table-management/table-management.component.html
// module chunks = main